module.exports = __webpack_public_path__ + "img/Gazprom_80X30.2424ccfa.png";